"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.statsigIntegration = void 0;

var _core = require("@sentry/core");

var _featureFlags = require("../../../utils/featureFlags.js");

/**
 * Sentry integration for capturing feature flag evaluations from the Statsig js-client SDK.
 *
 * See the [feature flag documentation](https://develop.sentry.dev/sdk/expected-features/#feature-flags) for more information.
 *
 * @example
 * ```
 * import { StatsigClient } from '@statsig/js-client';
 * import * as Sentry from '@sentry/browser';
 *
 * const statsigClient = new StatsigClient();
 *
 * Sentry.init({
 *   dsn: '___PUBLIC_DSN___',
 *   integrations: [Sentry.statsigIntegration({featureFlagClient: statsigClient})],
 * });
 *
 * await statsigClient.initializeAsync();  // or statsigClient.initializeSync();
 *
 * const result = statsigClient.checkGate('my-feature-gate');
 * Sentry.captureException(new Error('something went wrong'));
 * ```
 */
const statsigIntegration = exports.statsigIntegration = (0, _core.defineIntegration)(({
  featureFlagClient: statsigClient
}) => {
  return {
    name: 'Statsig',

    processEvent(event, _hint, _client) {
      return (0, _featureFlags.copyFlagsFromScopeToEvent)(event);
    },

    setup() {
      statsigClient.on('gate_evaluation', event => {
        (0, _featureFlags.insertFlagToScope)(event.gate.name, event.gate.value);
      });
    }

  };
});